import { clsx } from 'clsx';

type HeadingProps = {
  as?: 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  dark?: boolean;
} & React.ComponentPropsWithoutRef<'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'>;

export function PageHeading({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'h1'>): React.JSX.Element {
  return (
    <h1
      className={clsx(
        className,
        'text-base/7 font-semibold text-green-700 dark:text-green-400 mb-2',
      )}
      {...props}
    />
  );
}

export function Heading({
  className,
  as: Element = 'h2',
  dark = false,
  textStyle = 'text-pretty',
  ...props
}: HeadingProps & {
  textStyle?: 'text-pretty' | 'text-balance';
}): React.JSX.Element {
  return (
    <Element
      {...props}
      data-dark={dark ? 'true' : undefined}
      className={clsx(
        className,
        textStyle,
        'text-3xl font-medium tracking-tighter text-foreground data-dark:text-white sm:text-5xl leading-tight',
      )}
    />
  );
}

export function Subheading({
  className,
  as: Element = 'h2',
  dark = false,
  ...props
}: HeadingProps): React.JSX.Element {
  return (
    <Element
      {...props}
      data-dark={dark ? 'true' : undefined}
      className={clsx(
        className,
        'font-mono text-xs/5 font-semibold tracking-widest text-muted-foreground uppercase data-dark:text-gray-400',
      )}
    />
  );
}

export function Lead({
  className,
  fontSize = 'xl',
  ...props
}: React.ComponentPropsWithoutRef<'p'> & {
  fontSize?: 'xl' | 'lg' | 'base' | 'md' | 'sm';
}): React.JSX.Element {
  return (
    <p
      className={clsx(className, `text-${fontSize}`, 'font-medium text-muted-foreground')}
      {...props}
    />
  );
}
